// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveyFormList_container__3R_sc","loadingContainer":"SurveyFormList_loadingContainer__1LGtN"};